import EStyleSheet from 'react-native-extended-stylesheet';

const styles = EStyleSheet.create({
	outsideContainer: {
		backgroundColor: '$red',
		alignItems: 'center',
		justifyContent: 'center',
		zIndex: -1,
	},
	queContainer: {
		backgroundColor: '$green',
		alignItems: 'center',
		justifyContent: 'center',
		zIndex: -1,
	},
	queTitle: {
		color: '$text',
		fontFamily: '$fontMedium',
		fontSize: '.8rem',
	},
	connectContainer: {
		backgroundColor: '$greyLight',
		alignItems: 'center',
		justifyContent: 'center',
		zIndex: -1,
	},
	connectTitle: {
		fontFamily: '$fontMedium',
		fontSize: '.8rem',
	},
	outsideTitle: {
		color: 'white',
		fontFamily: '$fontMedium',
		fontSize: '.8rem',
	},
});

export default styles;
